import React, { CSSProperties } from "react";

import { breakpoints } from "@styles/responsive";
import { styled, Theme } from "@styles/theme";
import { formatProp, responsiveStyling, Responsive } from "@styles/responsive";

import { Box, Flex } from "./ResponsiveBox";

interface RowProps {
  gutter?: boolean;
  alignItems?: CSSProperties["alignItems"];
  justify?: CSSProperties["justifyContent"];
}

export const Row = styled(Box)<RowProps>`
  position: relative;
  display: flex !important;
  flex-wrap: wrap;
  align-items: ${(p) => p.alignItems || "initial"};
  justify-content: ${(p) => p.justify || "initial"};
  width: 100% !important;

  @media (min-width: ${breakpoints[0]}px) {
    & > .row__column {
      padding: 0 ${(p) => (p.gutter === false ? "0" : p.theme.spacing.lg)} 0 0;

      &:last-of-type:not(:first-of-type) {
        padding: 0 0 0 ${(p) => (p.gutter === false ? "0" : p.theme.spacing.lg)};
      }
    }
  }
`;

interface Props {
  size: Responsive<number>;
}

const GRID_SIZE = 12;

const ColWrapper = styled(Flex)<Props>`
  ${(p) => {
    const formattedSizes = formatProp(p.size, 12);
    const sizes = formattedSizes.map(
      (s) => `calc(100% * (${s} / ${GRID_SIZE}))`,
    );
    return responsiveStyling({
      width: sizes,
    });
  }};

  ${(p) => {
    const formattedSizes = formatProp(p.size, 12);
    const styles = formattedSizes.map((f, i) => {
      return f === 12
        ? `
            @media (max-width: ${breakpoints[i] + 1}px) {
              padding-right: 0 !important;
            }
          `
        : ``;
    });

    return styles;
  }};

  & > * {
    width: 100%;
  }
`;

export const Col: React.FC<React.ComponentProps<typeof ColWrapper>> = ({
  size = 1,
  children,
  ...props
}) => (
  <ColWrapper size={size} {...props} className="row__column">
    {children}
  </ColWrapper>
);

export const Decoration = styled.div<{
  color: keyof Theme["colors"];
  weight: number;
}>`
  top: 0;
  left: 0;
  width: 3px;
  height: 100%;
  position: absolute;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  background-color: ${(p) =>
    // @ts-ignore
    p.theme.colors?.[p.color]?.[p.weight] || "red"};
`;
